import { useCallback } from 'react';
import type { DoiTuongSearchParams } from '@/types/schemas';
import { getTableColumns } from '../cols-definition';
import { useDynamicSearch } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

interface UseSearchTableProps {
  searchData: (filters: DoiTuongSearchParams, page?: number, searchPageSize?: number) => Promise<void>;
  isFiltered: boolean;
  handlePageChange: (page: number) => Promise<void>;
}

export const useSearchTable = ({ searchData, isFiltered, handlePageChange }: UseSearchTableProps) => {
  const onSearch = useCallback(
    async (params: DoiTuongSearchParams) => {
      await searchData(params);
    },
    [searchData]
  );

  const getColumns = useCallback(() => {
    const cols = getTableColumns(() => {});
    return cols.map(col => ({
      field: col.field,
      type: col.type
    }));
  }, []);

  const { searchState, handleSearchChange, handleSearchPageChange, hasFilterParams, handleRefreshClick, isSearching } =
    useDynamicSearch({
      onSearch,
      params: {},
      getColumns,
      endpoint: `${QUERY_KEYS.NHA_CUNG_CAP}/filter`,
      pageSize: 20
    });

  const onPageChange = useCallback(
    async (page: number) => {
      if (hasFilterParams) {
        await handleSearchPageChange(page);
      } else if (isFiltered) {
        await searchData({}, page);
      } else {
        await handlePageChange(page);
      }
    },
    [hasFilterParams, handleSearchPageChange, isFiltered, searchData, handlePageChange]
  );

  return {
    searchState,
    handleSearchChange,
    onPageChange,
    hasFilterParams,
    handleRefreshClick,
    isFiltering: isSearching
  };
};
